import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3a9 9 0 0 0-8.972 9.712l6.082-1.52a3.001 3.001 0 0 1 5.78 0l6.082 1.52Q21 12.36 21 12a9 9 0 0 0-9-9m-1 17.945a9.01 9.01 0 0 1-7.594-6.266l5.85-1.463A3 3 0 0 0 11 14.83zm2 0a9.01 9.01 0 0 0 7.594-6.266l-5.85-1.463A3 3 0 0 1 13 14.83zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }